export function finishFormTrack() {
  if (window._lt) {
    console.log("line:send");
    window._lt("send", "cv", { type: "Submit" }, [
      "ba337053-cd82-4292-a234-0faec2a1d66a",
    ]);
  }
}
